import { ReferenceBusinessId } from "@sp-crm/core";
import { useQuery } from "@tanstack/react-query";
import { trpc } from "components/rpc/trpc";
import { stableQueryOptionsRpc } from "util/requests";

export interface ReferenceBusinessAiSummaryAccess {
    canManage: boolean;
}

export const useReferenceBusinessAiSummaryAccessQuery = (
    referenceBusinessId: ReferenceBusinessId | null,
) => {
    const trpcClient = trpc.useTRPC();

    return useQuery({
        ...trpcClient.referenceBusinessAiSummary.access.queryOptions({
            entityId: referenceBusinessId!,
        }),
        ...stableQueryOptionsRpc(),
        enabled: referenceBusinessId !== null,
    });
};

export const useReferenceBusinessAiSummaryAccess = (
    referenceBusinessId: ReferenceBusinessId | null,
): ReferenceBusinessAiSummaryAccess => {
    const accessQuery = useReferenceBusinessAiSummaryAccessQuery(referenceBusinessId);

    return { canManage: accessQuery.data?.canManage ?? false };
};
